import { __decorate } from "tslib";
import { EType } from '@blade/common/interfaces/user-group';
import { StaffModule } from '@blade-sxp/pass/store/staff';
import { Component, Vue } from 'vue-property-decorator';
import { handleError } from '@blade/common/utils/handle-error';
import { mapTags } from '@blade-sxp/pass/utils/map-tree';
import TreePopover from '@blade-sxp/pass/components/tree-popover.vue';
import { validateOnlyAlphanumeric } from '@blade/common/utils/validate';
let default_1 = class extends Vue {
    title = '';
    form = { user_name: '', access: '' };
    tags = [];
    id = '';
    data = [];
    get whitegroup() {
        return {
            user_name: {
                required: true,
                trigger: ['blur', 'change'],
                validator: (rule, value, callback) => {
                    if (!value) {
                        callback(new Error(this.$t('groupError').toString()));
                    }
                    else if (!validateOnlyAlphanumeric(value)) {
                        callback(new Error(this.$t('passManagement.groupNameError').toString()));
                    }
                    else {
                        callback();
                    }
                },
            },
        };
    }
    handleClick(e) {
        const res = e.filter((item) => item.type && Number(item.type) === 1);
        console.log('tags:', e);
        this.tags = res;
    }
    handleClose(e) {
        const res = this.tags.filter((item) => item.id !== e.id);
        this.tags = res;
    }
    handleDelete() {
        this.tags = [];
    }
    mounted() {
        const { meta, params } = this.$route;
        console.log('router:', meta);
        this.title = meta.page;
        this.id = params.id;
        if (meta.page === 'editWhiteGroup') {
            this.getWhite();
        }
    }
    handleSubmit() {
        this.$refs['group-form'].validate((valid) => {
            if (valid) {
                if (this.title === 'createWhiteGroup') {
                    this.createStaff();
                }
                else {
                    this.updateStaff();
                }
            }
            else {
                console.log('error submit!!');
                return false;
            }
        });
    }
    async getWhite() {
        try {
            const res = await StaffModule.getStaffById(this.id);
            console.log('res:', res);
            this.form.user_name = res.data.name;
            this.tags = mapTags(res.data);
            // console.log("tags:", this.tags)
        }
        catch (e) { }
    }
    async createStaff() {
        const res = this.tags.length > 0 ? this.tags.map((item) => item.id) : [];
        console.log('res:', res);
        try {
            await StaffModule.createStaff({
                maxSize: 0,
                name: this.form.user_name,
                remark: '',
                personGroup: EType.USER,
                userIds: res,
            });
            this.$elmessage.success(this.$t('whiteGroup').toString());
            this.$router.push({ path: '/traffic/staff/white', query: { group: 'GROUP' } });
        }
        catch (e) {
            handleError(e);
        }
    }
    async updateStaff() {
        const res = this.tags.length > 0 ? this.tags.map((item) => item.id) : [];
        try {
            await StaffModule.updateStaff({
                id: this.id,
                name: this.form.user_name,
                remark: '',
                userIds: res,
            });
            this.$elmessage.success(this.$t('editSuccess').toString());
            this.$router.push({ path: '/traffic/staff/white', query: { group: 'GROUP' } });
        }
        catch (e) {
            handleError(e);
        }
    }
    handleCancel() {
        this.$router.push({ path: '/traffic/staff/white', query: { group: 'GROUP' } });
    }
};
default_1 = __decorate([
    Component({
        components: { TreePopover },
        name: 'WhiteGroup',
        i18n: {
            messages: {
                'en-us': {
                    upload: 'Please upload the portrait',
                    createWhiteGroup: 'Create Allowlist',
                    groupName: 'Allowlist Name',
                    groupAccess: 'Allowlist Access',
                    access: 'Please input name/organization',
                    submit: 'Submit',
                    cancel: 'Cancel',
                    editWhiteGroup: 'Edit Allowlist Group',
                    groupError: 'Please input group',
                    groupNumber: 'Group Number',
                    remark: 'Remark',
                    gNumberE: 'Please input number',
                    whiteGroup: 'Successfully created allowlist Group',
                    editSuccess: 'Successfully edited',
                },
                zh: {
                    upload: '请上传人像',
                    createWhiteGroup: '创建白名单组',
                    groupName: '人员组名称',
                    groupAccess: '人员组权限',
                    access: '请输入姓名/部门',
                    submit: '确认',
                    cancel: '取消',
                    editWhiteGroup: '编辑白名单组',
                    groupError: '请输入人员组名称',
                    groupNumber: '人员组数量',
                    remark: '备注',
                    gNumberE: '请输入人员组数量',
                    whiteGroup: '成功创建白名单组',
                    editSuccess: '修改成功',
                },
            },
        },
    })
], default_1);
export default default_1;
